import { useEffect, useState } from "react";
import Lenis from "lenis";
import SiteNav from "@/components/SiteNav";
import Hero from "@/components/Hero";
import IntroRibbon from "@/components/IntroRibbon";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Process from "@/components/Process";
import Agenda from "@/components/Agenda";
import Founders from "@/components/Founders";
import Territory from "@/components/Territory";
import Questions from "@/components/Questions";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminPage from "@/components/AdminPage";
import ChatWidget from "@/components/ChatWidget";
import "@/index.css";
import "@/blankwater.css";

function PublicSite() {
  const [preferredDate, setPreferredDate] = useState(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ autoRaf: false, anchors: true, duration: 0.85 });
    let raf = 0;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const pickDate = (date) => {
    setPreferredDate(date);
    const el = document.getElementById("offerte");
    if (el) window.scrollTo({ top: el.offsetTop - 70, behavior: "smooth" });
  };

  return (
    <>
      <a className="skip" href="#diensten" data-testid="skip-link">
        Naar de inhoud
      </a>
      <SiteNav />
      <main>
        <Hero />
        <IntroRibbon />
        <Marquee />
        <Services />
        <Process />
        <Agenda onPickDate={pickDate} />
        <Founders />
        <Territory />
        <Questions />
        <Contact preferredDate={preferredDate} onClearDate={() => setPreferredDate(null)} />
      </main>
      <Footer />
      <ChatWidget />
    </>
  );
}

export default function App() {
  const isAdminRoute =
    typeof window !== "undefined" && window.location.pathname.replace(/\/+$/, "") === "/beheer";
  return isAdminRoute ? <AdminPage /> : <PublicSite />;
}
